import { getP44Env } from '@project44/ui-utils';

const { VOC_BASE_URL } = getP44Env();

export const MY_PROFILE_URL = `${VOC_BASE_URL}/portal/my-profile`;
export const VOC_URL = `${VOC_BASE_URL}/portal/v2/dashboard`;
